/*
 * Create slug from title
 * @param {String} title
 * @return {String} slug
 */
import { kebabCase } from 'lodash';

export default function (title): string {
    return kebabCase(title.replace(/&/g,'-'));
}